<div class="content" *ngIf="container" style="padding: 5px">
  <form (submit)="save()" #aform #formRef="ngForm" (change)="formChanged = true">
    <div class="alert alert-danger" role="alert" *ngIf="errorMsg">
      <em class="material-icons">warning</em>
      <span class="sr-only">Error:</span> {{ errorMsg }}
    </div>
    <div class="row" title="Toolbar">
      <div class="col-md-8">
        <div class="page-header">
          <div
            class="help-block h4"
            [ngStyle]="{
              cursor: !formRef.form.valid ? 'not-allowed' : 'pointer'
            }"
          >
            Container Entry {{ container.shipped ? "(Shipped)" : "" }}

            <close-button></close-button>
            <!-- <button type="reset" class="btn btn-outline-secondary pull-right">
              <mat-icon>restart_alt</mat-icon>
            </button> -->
            <button
              type="submit"
              class="btn btn-outline-secondary pull-right"
              [disabled]="!formRef.form.valid"
            >
              <mat-icon title="Save">save</mat-icon>
              <span style="color: salmon; font-weight: bold">{{ formChanged ? "*" : "" }}</span>
            </button>

            <button
              *ngIf="container.canDelete"
              type="button"
              (click)="remove(container.id)"
              class="btn btn-outline-secondary pull-right"
            >
              <mat-icon>delete</mat-icon>
            </button>
            <button
              *ngIf="!container.isNew"
              title="Make copies of this Container"
              type="button"
              (click)="copyOpen()"
              class="btn btn-outline-secondary pull-right"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
            <button
              *ngIf="container.canClose"
              type="button"
              title="{{ container.approved ? 'Remove Approval' : 'Approve the Container' }}"
              (click)="approveContainer()"
              class="btn btn-outline-secondary pull-right"
            >
              <mat-icon>{{ container.approved ? "bookmark_added" : "bookmark_border" }}</mat-icon>
            </button>
            <button
              *ngIf="container.canApprove"
              type="button"
              title="{{ container.open ? 'Close' : 'Open' }}"
              (click)="closeContainer()"
              class="btn btn-outline-secondary pull-right"
            >
              <mat-icon>{{ container.open ? "lock_open" : "lock" }}</mat-icon>
            </button>
          </div>
          <hr />
        </div>
      </div>
    </div>
    <div>
      <div title="Header" class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label for="trackingNumber"> Manifest </label>
                <input
                  title="Move to another Manifest"
                  readonly
                  required
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.trackingNumber"
                  name="trackingNumber"
                  style="
                    background-color: #00aeef;
                    cursor: pointer;
                    color: #fff;
                    text-align: center;
                    font-size: large;
                  "
                  (click)="openMove(container.wasteType)"
                />
              </div>
            </div>
            <div class="col-md-2">
              <label for="wasteType">Waste Type</label>
              <input
                readonly
                required
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.wasteType"
                name="wasteType"
              />
            </div>
            <div class="col-md-2">
              <label for="containerNumber"> Container Number </label>
              <input
                [required]="!container.isNew"
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.containerNumber"
                name="containerNumber"
              />
            </div>
            <div class="col-md-2">
              <label for="startDate">Date Opened </label>
              <input
                required
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.startDate"
                name="approvedDate"
                bsDatepicker
                [(bsValue)]="container.startDate"
              />
            </div>
            <div class="col-md-2">
              <label for="enteredBy">Entered By CAI </label>
              <div class="input-group">
                <input
                  type="text"
                  autocomplete="off"
                  required
                  readonly
                  class="form-control"
                  placeholder="CAI"
                  [(ngModel)]="container.enteredBy"
                  name="enteredBy"
                />
                <span class="input-group-btn">
                  <button
                    ftype="button"
                    style="width: 50px; margin: 0"
                    class="btn btn-outline-secondary form-control"
                    (click)="enteredByPicker.show()"
                  >
                    <mat-icon>search</mat-icon>
                  </button>
                </span>
              </div>
            </div>
            <div class="col-md-2">
              <label for="enteredByName"> Entered By Name </label>
              <div name="enteredByName" style="font-size: 17px; position: relative; top: 15%">
                {{ container.enteredByName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div title="Ownership" class="card" *ngIf="container.wasteType == 'Bulk'">
        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <label for="owner">Owner CAI </label>
              <div class="input-group">
                <input
                  type="text"
                  autocomplete="off"
                  readonly
                  class="form-control"
                  placeholder="CAI"
                  [(ngModel)]="container.owner"
                  name="owner"
                />
                <span class="input-group-btn">
                  <button
                    type="button"
                    style="width: 50px; margin: 0"
                    class="btn btn-outline-secondary form-control"
                    (click)="peoplePicker.show()"
                  >
                    <mat-icon>search</mat-icon>
                  </button>
                </span>
              </div>
            </div>
            <div class="col-md-2">
              <label for="ownerName"> Owner Name / Phone </label>
              <div name="ownerName" style="font-size: 17px; position: relative; top: 15%">
                {{ container.ownerName }} - {{ container.phone }}
              </div>
            </div>
            <div class="col-md-2">
              <label for="labNo">Lab Number </label>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.labNo"
                name="labNo"
              />
            </div>
            <div class="col-md-3">
              <label for="office"> Building Number </label>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.office"
                name="office"
              />
            </div>
            <div class="col-md-2">
              <label for="chargeCode"> Charge Code</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.chargeCode"
                name="chargeCode"
              />
            </div>
          </div>
        </div>
      </div>
      <div title="Container Detail" class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <label for="containerDetail"> Container Detail </label>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.containerDetail"
                name="containerDetail"
              />
            </div>
            <div class="col-md-3">
              <label for="facilityName">Disposal Facility </label>
              <select class="form-select" [(ngModel)]="container.facilityName" name="facilityName">
                <option *ngFor="let k of facilitiescompanies">{{ k }}</option>
              </select>
            </div>
            <div class="col-md-1">
              <label for="containerType">Type </label>
              <select
                class="form-select"
                [(ngModel)]="container.containerType"
                name="containerType"
              >
                <option *ngFor="let k of containerTypes" [value]="k.code">{{ k.code }}</option>
              </select>
            </div>
            <div class="col-md-2">
              <label for="volume">Volume </label>
              <div class="input-group">
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.volume"
                  name="volume"
                />&nbsp;
                <select class="form-select" [(ngModel)]="container.volumeUnits" name="volumeUnits">
                  <option></option>
                  <option *ngFor="let k of unitsV" [value]="k">{{ k }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <label for="weight">Weight </label>
              <div class="input-group">
                <input
                  type="number"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.weight"
                  name="weight"
                />&nbsp;
                <select class="form-select" [(ngModel)]="container.weightUnits" name="weightUnits">
                  <option></option>
                  <option *ngFor="let k of unitsW" [value]="k">{{ k }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-1">
              <label for="ownerName"> Items Total Weight </label>
              <div name="ownerName" style="font-size: 17px; position: relative; top: 15%">
                {{ container.itemsWeight }} {{ container.weightUnits }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div title="Waste Profile" class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <input-filter
                [disabled]="container.wasteType !== 'Bulk'"
                [data]="wasteStreams"
                [key]="'name'"
                [searchertext]="'Waste Stream'"
                [searchText]="container.streamName"
                (itemSelectedEvent)="setWasteStream($event)"
              ></input-filter>
            </div>
            <div class="col-md-4">
              <label for="dotDescription">Dot Description </label>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.dotDescription"
                name="dotDescription"
              />
            </div>
            <div class="col-md-1">
              <div>
                <label for="toxic">Toxic </label>
              </div>
              <input
                style="height: 30px; width: 30px"
                type="checkbox"
                [(ngModel)]="container.toxic"
                name="toxic"
              />
            </div>
            <div class="col-md-1">
              <div>
                <label for="reactive">Reactive</label>
              </div>
              <input
                style="height: 30px; width: 30px"
                type="checkbox"
                [(ngModel)]="container.reactive"
                name="reactive"
              />
            </div>
            <div class="col-md-1">
              <div>
                <label for="ignitable">Ignitable</label>
              </div>
              <input
                style="height: 30px; width: 30px"
                type="checkbox"
                [(ngModel)]="container.ignitable"
                name="ignitable"
              />
            </div>
            <div class="col-md-1">
              <div>
                <label for="corrosive">Corrosive</label>
              </div>
              <input
                style="height: 30px; width: 30px"
                type="checkbox"
                [(ngModel)]="container.corrosive"
                name="corrosive"
              />
            </div>
            <div class="col-md-1">
              <label for="hm">HM</label>
              <div>
                <input
                  style="height: 30px; width: 30px"
                  type="checkbox"
                  [(ngModel)]="container.hm"
                  name="hm"
                />
              </div>
            </div>
          </div>

          <!-- TSDF Profile -->
          <div class="row">
            <div class="col-md-2">
              <label for="tsdfProfile">TSDF Profile # </label>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.tsdfProfile"
                name="tsdfProfile"
              />
            </div>
            <div class="col-md-2">
              <input-filter
                [data]="tsdfCodes"
                [key]="'code'"
                [searchertext]="'TSDF Disposal Code'"
                [searchText]="container.tsdfDisposalCode"
                (itemSelectedEvent)="setDisposalCode($event)"
              ></input-filter>
            </div>
            <div class="col-md-2">
              <label for="physicalStateId">Physical State </label>
              <select
                class="form-select"
                [(ngModel)]="container.physicalStateId"
                name="physicalStateId"
              >
                <option *ngFor="let k of physicalStateOptions" [value]="k">{{ k }}</option>
              </select>
            </div>

            <div class="col-md-2">
              <label for="ergNumber"> ERG # </label>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.ergNumber"
                name="ergNumber"
              />
            </div>
            <div class="col-md-2">
              <label for="binId">Bin ID </label>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.binId"
                name="binId"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <label for="stateWasteCode">State Waste Code </label>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="container.stateWasteCode"
                name="stateWasteCode"
                placeholder="State Waste Code"
              />
            </div>
            <div class="col-md-10">
              <label for="wasteCode01"> EPA Waste Codes:</label>

              <div class="input-group">
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.wasteCode01"
                  name="wasteCode01"
                  placeholder="#1"
                  maxlength="4"
                  (keyup)="wcChanged($event)"
                />
                &nbsp;
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.wasteCode02"
                  name="wasteCode02"
                  placeholder="#2"
                  maxlength="4"
                  (keyup)="wcChanged($event)"
                />&nbsp;
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.wasteCode03"
                  name="wasteCode03"
                  placeholder="#3"
                  maxlength="4"
                  (keyup)="wcChanged($event)"
                />&nbsp;
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.wasteCode04"
                  name="wasteCode04"
                  placeholder="#4"
                  maxlength="4"
                  (keyup)="wcChanged($event)"
                />
                &nbsp;
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.wasteCode05"
                  name="wasteCode05"
                  placeholder="#5"
                  maxlength="4"
                  (keyup)="wcChanged($event)"
                />
                &nbsp;
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.wasteCode06"
                  name="wasteCode06"
                  placeholder="#6"
                  maxlength="4"
                  (keyup)="wcChanged($event)"
                />
                &nbsp;
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.wasteCode07"
                  name="wasteCode07"
                  placeholder="#7"
                  maxlength="4"
                  (keyup)="wcChanged($event)"
                />
                &nbsp;
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.wasteCode08"
                  name="wasteCode08"
                  placeholder="#8"
                  maxlength="4"
                  (keyup)="wcChanged($event)"
                />
                &nbsp;
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.wasteCode09"
                  name="wasteCode09"
                  placeholder="#9"
                  maxlength="4"
                  (keyup)="wcChanged($event)"
                />
                &nbsp;
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="container.wasteCode10"
                  name="wasteCode10"
                  placeholder="#10"
                  maxlength="4"
                  (keyup)="wcChanged($event)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <br />
  <div class="card" title="Items Header">
    <div class="card-header">
      <div class="row">
        <div class="col-md-2">
          <dl>
            <dt>
              <a
                *ngIf="!container.isNew && container.open"
                title="Add new Item"
                class="circle circle-add"
                (click)="navigateToAddItem()"
              >
                <em class="material-icons-outlined">create</em> </a
              >&nbsp;Item
            </dt>
          </dl>
        </div>
        <div class="col-md-3">
          <dt>Description</dt>
        </div>
        <div class="col-md-2">
          <dt>Stream Name</dt>
        </div>
        <div class="col-md-1">
          <dt>Quantity</dt>
        </div>
        <div class="col-md-1">
          <dt>Physical State</dt>
        </div>
        <div class="col-md-1">
          <dt>Volume</dt>
        </div>
        <div class="col-md-1">
          <dt>Weight</dt>
        </div>
        <div *ngIf="container.isLabPack" class="col-md-1">
          <dt>Waste Codes</dt>
        </div>
      </div>
    </div>
  </div>
  <div title="Items Body" *ngFor="let item of items" class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-2">
          <dd>
            <a
              class="circle"
              title="View details"
              *ngIf="container.canView"
              routerLink="/items/{{ item.itemNumber }}"
            >
              <em class="material-icons-outlined">visibility</em>
            </a>
            <a
              title="Modify"
              class="circle"
              *ngIf="container.open"
              routerLink="/items/{{ item.itemNumber }}/edit"
            >
              <em class="material-icons">edit</em>
            </a>
            &nbsp;{{ item.itemNumber }}
          </dd>
        </div>
        <div class="col-md-3">
          <dd>{{ item.description }}</dd>
        </div>
        <div class="col-md-2">
          <dd>{{ item.streamName }}</dd>
        </div>
        <div class="col-md-1">
          <dd>{{ item.numberOfItems }}</dd>
        </div>
        <div class="col-md-1">
          <dd>{{ item.physicalState }}</dd>
        </div>
        <div class="col-md-1">
          <dd>{{ item.volumeUn }}</dd>
        </div>
        <div class="col-md-1">
          <dd>{{ item.weightUn }}</dd>
        </div>
        <div *ngIf="container.isLabPack" class="col-md-1">
          <dd>{{ item.wasteCodesJoin }}</dd>
        </div>
      </div>
    </div>
  </div>

  <div
    title="Move to Manifest"
    class="modal my-modal-wrapper fade"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    #moveModal
    id="moveModal"
    [config]="{ backdrop: 'static', keyboard: false }"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" style="text-align: center">
          <h3>
            {{ wasteType ? wasteType + " Manifests" : "Select a Waste Type" }}
          </h3>
          <a style="height: 30px" class="circle close" (click)="closeMove()">
            <mat-icon>close</mat-icon>
          </a>
        </div>
        <div class="modal-body">
          <div style="text-align: center" *ngIf="!wasteType">
            <a
              class="btn btn-outline-secondary btn-lg"
              style="width: 20%"
              (click)="selectType('Bulk')"
            >
              Bulk
            </a>
            <a
              class="btn btn-outline-secondary btn-lg"
              style="width: 20%"
              (click)="selectType('LabPack')"
            >
              LabPack
            </a>
            <a
              class="btn btn-outline-secondary btn-lg"
              style="width: 20%"
              (click)="selectType('Recycle')"
            >
              Recycle
            </a>
          </div>
          <div *ngIf="wasteType">
            <div class="input-group">
              <input
                #filterbox
                type="text"
                class="form-control"
                placeholder="Filter..."
                name="containerFilter"
                (keyup)="filterMove(filterbox.value, $event)"
                (keydown.enter)="filterMove(filterbox.value, $event)"
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  style="width: 90px; margin: 0"
                  class="btn btn-primary form-control"
                  (click)="filterMove(filterbox.value, $event)"
                >
                  <mat-icon>search</mat-icon>
                </button>
              </span>
            </div>
            <br />
            <div *ngIf="unshippedManifests">
              <div style="overflow-y: scrautooll; height: 580px" class="list-group">
                <a
                  class="list-group-item"
                  *ngFor="let item of unshippedManifests"
                  (click)="selectMove(item)"
                >
                  {{ item.trackingNumber }} - Shipping Date:
                  {{ item.shippingDate | date : "MM/dd/yyyy" }}
                </a>
              </div>
              <pager
                [items]="unshippedManifests.paging"
                (pageChanged)="pageMove($event)"
                [options]="{
                  shouldShowFirstPageLink: true,
                  shouldShowNextPageLink: true,
                  shouldShowPreviousPageLink: true,
                  shouldShowLastPageLink: true
                }"
              >
              </pager>
            </div>
          </div>
          <br />
          <br />
          <div class="modal-footer">
            <button
              *ngIf="wasteType && container.isNew"
              type="button"
              class="btn btn-outline-secondary"
              (click)="openMove()"
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    title="Copy Container"
    class="modal my-modal-wrapper fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    #copyModal
    id="copyModal"
  >
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" style="text-align: center">
          <h3>Copy Container</h3>
          <a class="circle close" (click)="copyClose()">
            <mat-icon>close</mat-icon>
          </a>
        </div>
        <div class="modal-body">
          <label for="copyQty" class="form-label">Quantity: {{ copyQty }}</label>
          <div class="form-group">
            <span>1</span>
            <input
              style="width: 90%"
              type="range"
              id="copyQty"
              name="copyQty"
              min="1"
              max="20"
              step="1"
              class="form-range"
              [(ngModel)]="copyQty"
            />
            <span>20</span>
          </div>
          <br />
          <br />
          <div class="modal-footer">
            <a title="Apply" class="circle circle-add" (click)="copyApply()">
              <mat-icon>copy_all</mat-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <people-picker #peoplePicker (personSelected)="setOwner($event)"></people-picker>
  <people-picker #enteredByPicker (personSelected)="setEnteredBy($event)"></people-picker>
</div>
